var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border card-content-hover shadow shadow-sm"},[_c('div',{staticClass:"content  p-3"},[_c('img',{staticClass:"w-100 text-center img-content",attrs:{"src":_vm.image,"alt":_vm.alt}}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }